import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = {
  class: "page-section bg-light",
  id: "support"
}
const _hoisted_2 = { class: "py-5" }
const _hoisted_3 = { class: "container" }
const _hoisted_4 = { class: "row align-items-center" }
const _hoisted_5 = { href: "#!" }
const _hoisted_6 = ["src", "aria-label"]

import { sponsors } from '@/data/sponsors'

export default /*@__PURE__*/_defineComponent({
  __name: 'SponsorSection',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _cache[0] || (_cache[0] = _createElementVNode("div", { class: "text-center" }, [
          _createElementVNode("h2", { class: "section-heading text-uppercase" }, "Sponsors"),
          _createElementVNode("h3", null, "You can support us too with PayPal. Click Donate and select \"First Robotics\"."),
          _createElementVNode("form", {
            action: "https://www.paypal.com/donate",
            method: "post",
            target: "_donate"
          }, [
            _createElementVNode("input", {
              type: "hidden",
              name: "hosted_button_id",
              value: "NR8SF5LHQW45E"
            }),
            _createElementVNode("input", {
              type: "image",
              src: "https://www.paypalobjects.com/en_US/i/btn/btn_donate_LG.gif",
              border: "0",
              name: "submit",
              title: "Select First Robotics",
              alt: "Donate with PayPal button"
            }),
            _createElementVNode("img", {
              alt: "",
              border: "0",
              src: "https://www.paypal.com/en_US/i/scr/pixel.gif",
              width: "1",
              height: "1"
            })
          ])
        ], -1)),
        _createElementVNode("div", _hoisted_4, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(sponsors), (sponsor) => {
            return (_openBlock(), _createElementBlock("div", {
              key: sponsor.name,
              class: "col-sm-6 p-4"
            }, [
              _createElementVNode("a", _hoisted_5, [
                _createElementVNode("img", {
                  class: "img-fluid",
                  style: _normalizeStyle({ width: sponsor.maxWidth || '100%', height: 'auto' }),
                  src: sponsor.logo,
                  alt: "...",
                  "aria-label": sponsor.name
                }, null, 12, _hoisted_6)
              ])
            ]))
          }), 128))
        ])
      ])
    ])
  ]))
}
}

})